import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "../../css/course-page.css";
import "../../css/main-mobile-view.css";
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import Courseschedule from '../Landing/Subcomponent/courseschedule';

class DataAnalytics extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item"><Link href="/"> <i className="icon-home"></i>HOME </Link></li>
                        <li class="breadcrumb-item active" aria-current="page">Post Graduate Program in Data Analytics</li>
                    </ol>
                </div>
                <section class="course-header bg-blue11" id="course-header">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg">
                            <h1>Post Graduate Program in <br />Data Analytics </h1> <br />
                            <p>Accelerate your Career. Stay Ahead of the Curve </p>
                            <br /><br />
                            <br />
                            <div class="form-group">
                                <a href="#subcribeplan" class="btn btn-md enroll-btn">Enroll Now </a>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/post-graduate-program-in-data-analytics');">Download
                        brochure</button><br /> <br />
                                <h3> Online Live Training</h3><br /> <br />
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                            <br />
                            <p>Jointly Delivered by </p>
                            <br />
                            <div class="row">
                                <div class="col-sm-5">
                                    <img alt="executive" width="" src="/assets/images/isi.svg" />
                                </div>
                                <div class="col-sm-1"></div>
                                <div class="col-sm-5">
                                    <img alt="executive2" width="" src="/assets/images/epn.svg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="course-main-contains def-z">
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;&nbsp;4 MONTHS<br />
                                    <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;&nbsp;4 MONTHS<br />
                                    <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKEND BATCH</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" >
                                <b><i class=" fa fa-calendar-o" ></i> &nbsp;&nbsp;&nbsp;WEEKDAY&nbsp; (MON - FRI)<br />
                                    <i class=" fa fa-calendar-o" ></i> &nbsp;&nbsp;&nbsp;WEEKEND&nbsp; (SAT - SUN)</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-12" id="Description">  <hr />
                                <span class="golden">Training Mode(Online)</span><br />
                                <b> <span class="font-for-batch"><i class="fa fa-calendar-o" aria-hidden="true"></i>  Date :05<sup>th</sup> June 2020-17<sup>th</sup> Oct 2021 </span></b> <br />
                                <b><span class="font-for-batch"><i class="fa fa-film" aria-hidden="true"></i>  Batch Type :Saturday-Sunday </span></b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-12">   <hr />
                                <span class="golden">Training Mode(Online)</span><br />
                                <b> <span class="font-for-batch"><i class="fa fa-calendar-o" aria-hidden="true"></i>  Date :17<sup>th</sup> May 2021-09<sup>nd</sup> Sep 2021</span></b> <br />
                                <b><span class="font-for-batch"><i class="fa fa-film" aria-hidden="true"></i>  Batch Type :Monday-Friday </span></b>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <section class="def-z" id="Description">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Industry">Industry Trends</a></li>
                            <li><a href="#tools">Tools</a></li>
                            <li><a href="#syllabus">Syllabus</a></li>
                            <li><a href="#Certification">Certification</a></li>
                            <li><a href="#Outcomes">Learning Outcomes</a></li>
                            <li><a href="#Schedule">Schedule</a></li>
                            <li><a href="#FAQs">FAQs</a></li>
                            <li class="btn-header cs-dx"><a href="#subcribeplan">Enroll Now</a> </li>
                        </ul>
                    </div>
                </section>
                <br />
                <section class="course-description" id="course-description">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Description</h3>
                            <p align="justify" class="Descriptionbold">The Post Graduate Program in Data Analytics is jointly created & delivered by Indian Statistical Institute, Pune and edu plus now along with industry experts.</p>
                            <p align="justify"> Our tailor-made curriculum includes Statistical Analysis, Text Mining, Regression Modeling, Hypothesis Testing, Predictive Analytics, Machine Learning using R, Python, Deep Learning, Neural Networks, Natural Language Processing, Predictive Modeling, Tableau, Power BI , Advance Excel etc. which will help you acquire in-demand skills and start a career as an accomplished data analytics professional.</p>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h5>Highlights</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <table class="table-highlight">
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl7.svg" />  Separate batches for working professional</td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience4" src="/assets/images/icons/hl1.svg" /> Advisory Board members from Industry & Academia </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience5" src="/assets/images/icons/hl2.svg" /> Capstone Project spanning throughout the course
                              duration
                           </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience6" src="/assets/images/icons/hl3.svg" /> Industry-Endorsed Curriculum </td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <table class="table-highlight">
                                <tr>
                                    <td> <img alt="datascience7" src="/assets/images/icons/hl4.svg" /> Aptitude and Soft Skills Development </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience8" src="/assets/images/icons/hl5.svg" /> Leading Technical Faculty with Domain Expertise </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience9" src="/assets/images/icons/hl6.svg" /> Placement Assistance</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-6">
                            <h5> Who Should Enroll? </h5>
                            <ul class="admission-ul">
                                <li> Fresh graduates with interest in Data Science, Machine Learning and AI</li>
                                <li id="Industry"> Working professionals / managers and above who would need to extract information from data that they routinely encounter from areas such as Retail, Banking, BPO, IT, Sales & Marketing, Supply chain, Strategic management, etc.</li>
                                <li> Software Programmers </li>
                                <li>Marketing and Sales Professionals</li>
                                <li> Individuals interested in Data Science</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <h5> Eligibility </h5>
                            <ul class="admission-ul">
                                <li> All Graduates / Post Graduates – Engineering, IT, Computer Science, Mathematics, Statistics, Actuarial Science, Economics, Life Science, Electronics</li>
                                <li>MBA All Streams</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section class="course-industry-trends bg-secondary" id="course-industry-trends">
                    <div class="row">
                        <div class=" col-md-6 col-sm-12">
                            <h3> Industry Trends </h3>
                            <br />
                            <h5>Job Roles</h5>
                            <ul class="industry-trends-ul">
                                <li>Data Analyst </li>
                                <li>Data Engineer </li>
                                <li>Data Scientist </li>
                                <li>Business Analyst </li>
                                <li id="tools">Machine Learning Engineer </li>
                            </ul>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <img alt="datascience11" src="/assets/images/icons/industry-trends.svg" />
                        </div>
                    </div>
                </section>
                <br />
                <section class="course-tools-covered" id="course-tools-covered">
                    <h3> Tools Covered </h3>
                    <br />
                    <div class="owl-carousel owl-theme" id="owl-carousel-course-tools">
                        <div class="item">
                            <div class="card" >
                                <center id="syllabus"> <img alt="datascience14" src="/assets/images/icons/rstudio-logo.png" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" >
                                <center><img alt="datascience15" src="/assets/images/icons/excel-logo.png" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" >
                                <center><img alt="datascience16" src="/assets/images/icons/python-logo.svg" /> </center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" >
                                <center><img alt="datascience17" src="/assets/images/icons/tableau-logo.png" /> </center>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="course-syllabus" id="course-syllabus">
                    <div class="row">
                        <div class="col-sm-6">
                            <br />
                            <h3> Syllabus </h3>
                            <br />
                            <div class="syl-bg">
                                <h5>Data Analytics, Machine Learning & Deep Learning</h5>
                                <div id="damldl_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="damldl_heading1" data-toggle="collapse"
                                                href="#damldl_syllabus1" aria-expanded="true" aria-controls="damldl_syllabus1">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Statistics Concepts
                                            </h6>
                                            </div>
                                            <div id="damldl_syllabus1" class="collapse show" aria-labelledby="damldl_heading1"
                                                data-parent="#damldl_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Basic Statistical concepts</li>
                                                        <li> Exploratory Data Analyses</li>
                                                        <li> Estimation and hypotheses testing</li>
                                                        <li> Multiple Linear Regressions</li>
                                                        <li> Categorical Data Analyses</li>
                                                        <li> Introduction to Logistic Regression for Classification and Risk
                                                        Analysis
                                                        </li>
                                                        <li> Regression Analysis</li>
                                                        <li> Classification using Linear and Quadratic Discriminant Analysis
                                                         </li>
                                                        <li> Classification using Support Vector Machines</li>
                                                        <li> Tree Based Methods</li>
                                                        <li> Principal Component Analysis and Factor Analysis </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="damldl_heading2" data-toggle="collapse"
                                                href="#damldl_syllabus2" aria-expanded="true"
                                                aria-controls="#damldl_syllabus2">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> R Studio
                                                </h6>
                                            </div>
                                            <div id="damldl_syllabus2" class="collapse show" aria-labelledby="damldl_heading2"
                                                data-parent="#damldl_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction to R and R studio</li>
                                                        <li> Vectors</li>
                                                        <li> Testing of hypothesis and Confidence Interval</li>
                                                        <li> Linear Regression </li>
                                                        <li> Logistic Regression</li>
                                                        <li> Decision Trees/CART </li>
                                                        <li> Supervised and Unsupervised learning</li>
                                                        <li> Naïve Bayes Classifier</li>
                                                        <li> Principal Component Analysis</li>
                                                        <li> Factor Analysis</li>
                                                        <li> Discriminant Analysis</li>
                                                        <li> Time Series Analysis</li>
                                                        <li> k-means clustering</li>
                                                        <li> Market Basket Analysis</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="damldl_heading3" data-toggle="collapse"
                                                href="#damldl_syllabus3" aria-expanded="true" aria-controls="damldl_syllabus3">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Advance Excel
                                 </h6>
                                            </div>
                                            <div id="damldl_syllabus3" class="collapse show" aria-labelledby="damldl_heading3"
                                                data-parent="#damldl_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Excel Worksheet Structuring</li>
                                                        <li> Formatting Tips</li>
                                                        <li> Reference Functions</li>
                                                        <li> Pivot Tables, Pivot Charts,Template, Consolidation</li>
                                                        <li> What if Analysis</li>
                                                        <li> Database Functions</li>
                                                        <li> Macro’s </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="damldl_heading5" data-toggle="collapse"
                                                href="#damldl_syllabus5" aria-expanded="true" aria-controls="damldl_syllabus5">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Machine Learning using Python
                                                 </h6>
                                            </div>
                                            <div id="damldl_syllabus5" class="collapse show" aria-labelledby="damldl_heading5"
                                                data-parent="#damldl_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Machine Learning</li>
                                                        <li> Types of Machine Learning</li>
                                                        <li> Phases of Machine Learning Project</li>
                                                        <li> Doing Machine Learning using Tool</li>
                                                        <li> Machine Learning Ecosystem in Python</li>
                                                        <li> Pandas for Data Preprocessing & Cleanup</li>
                                                        <li> Machine Learning Model Creation</li>
                                                        <li> Machine Learning Algorithms</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="damldl_heading6" data-toggle="collapse"
                                                href="#damldl_syllabus6" aria-expanded="true" aria-controls="damldl_syllabus6">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Deep Learning
                                                </h6>
                                            </div>
                                            <div id="damldl_syllabus6" class="collapse show" aria-labelledby="damldl_heading6"
                                                data-parent="#damldl_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Setting up the Environment</li>
                                                        <li> Theoretical Foundation of Deep Learning</li>
                                                        <li> Understanding Neural Networks ANN, CNN, RNN</li>
                                                        <li> Natural Language Processing</li>
                                                        <li> Computer Vision</li>
                                                        <li> image processing /text processing</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h5>Data Visualization</h5>
                                <div id="dv_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="dv_heading1" data-toggle="collapse"
                                                href="#dv_syllabus1" aria-expanded="true" aria-controls="dv_syllabus1">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Tableau
                                                 </h6>
                                            </div>
                                            <div id="dv_syllabus1" class="collapse show" aria-labelledby="dv_heading1"
                                                data-parent="#dv_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction</li>
                                                        <li> Visualization Design and Data Types</li>
                                                        <li> Tableau and Data Connections</li>
                                                        <li>Chart Types, Dashboards and Work Sharing </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="dv_heading2" data-toggle="collapse"
                                                href="#dv_syllabus2" aria-expanded="true" aria-controls="dv_syllabus2">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-minus"></i> Power BI
                                                </h6>
                                            </div>
                                            <div id="dv_syllabus2" class="collapse show" aria-labelledby="dv_heading2"
                                                data-parent="#dv_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction to Power BI</li>
                                                        <li> Extracting Data</li>
                                                        <li id="Certification"> Power Query for Data Transformation</li>
                                                        <li> Power Pivot for Data Modeling</li>
                                                        <li> Data Visualization with Analytics </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>Learning Outcomes</h3>
                            <br />
                            <ul class="lo-ul">
                                <li>Gain expertise in Data Engineering, Data Analytics Machine learning &
                                DataVisualization.
                            </li>
                                <li>Master descriptive and inferential statistics, hypothesis testing, regression analysis,
                                data blending, data extracts, and forecasting
                                </li>
                            </ul>
                            <br />
                            <h5>Assessment </h5>
                            <p align="justify" id="Schedule">
                                Periodic assessment and case studies evaluations by the Indian Statistical Institute,Pune (ISI)
                                and edu plus now have been built in throughout the duration of the course.
                            </p>
                        </div>
                        <div class="col-sm-6">
                            <img alt="datascience18" src="/assets/images/icons/certificate-final.png" />
                            <p class="img-below-text text-center">Awarded Jointly by The Indian Statistical Institute,Pune and
                            edu plus now
                        </p>
                        </div>
                    </div>
                </section>
                <Courseschedule />
                <Aboutuslearners />
                <Aluminicompany />
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                                <br /><h6>Course Fees :<i class='fa fa-inr ' ></i><b><span id='fee-gst' > 1,20,000</span></b><span class='fee-gst'> (+GST)</span></h6>

                            </div>
                            <div class="vertical-line-fee"> </div>
                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br />
                                        <h5>Features </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li>	Indian Statistical Institute as a knowledge partner.</li>
                                            <li>	Mentorship by industry specialists.</li>
                                            <li>	Course awarded by Edu Plus Now.</li>
                                            <li>Separate batches for working professional</li>
                                            <li>Advisory Board members from Industry & Academia</li>
                                            <li>Capstone Project spanning throughout the course duration</li>
                                            <li>Industry-Endorsed Curriculum</li>
                                        </ul>
                                    </div>
                                    <p>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3> About the Organization</h3>
                            <br />
                            <img alt="datascience23" width="" src="/assets/images/isi-black.svg" />
                            <br /><br />
                            <p align="justify">It is a Central Government institute, devoted to research, teaching & application of
                            not only statistics and allied sciences, but also the natural sciences, social
                            sciences and their interface with the statistics. Founded by Professor P.C.
                            Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                            an Institution of National Importance by an act of the Indian Parliament in 1959.
                                    </p>
                            <br />
                            <p id="FAQs" align="justify">ISI Pune is a unit of Indian Statistical Institute,Pune, active in Teaching, Training,
                            Research and Consulting on application of statistics, operations research & allied
                            science to solve problems of the industry across the spread and depth of the
                            industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                            TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                            Data Analytic, Data Science.
                                </p>
                        </div>
                    </div>
                </section>
                <section class="course-faq" id="course-faq">
                    <br />
                    <h3> FAQs </h3>
                    <br />
                    <div class="row">
                        <div class="col-sm-7 bg-secondary">
                            <br />
                            <div id="faqs">
                                <div class="panel-group">
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading1" data-toggle="collapse" href="#faqs1"
                                            aria-expanded="true" aria-controls="faqs1">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-minus"></i>  What tools will I learn with this course?
                                 </h6>
                                        </div>
                                        <div id="faqs1" class="collapse show" aria-labelledby="faqs_heading1"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> In this course, you will learn functional analytics, SQL, Statistical Analysis, Text Mining,
                                                    Regression Modelling, Hypothesis Testing, Predictive Analytics, Machine Learning using R,
                                                    Python, Deep Learning, Neural Networks, Natural Language Processing, Predictive
                                                    Modelling, Tableau, Spark, Hadoop, etc. All these tools will help you acquire in-demand skills
                                                    and start a career as an accomplished data scientist.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading2" data-toggle="collapse" href="#faqs2"
                                            aria-expanded="true" aria-controls="faqs2">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> How will a course in Data Analytics benefit me?
                                 </h6>
                                        </div>
                                        <div id="faqs2" class="collapse" aria-labelledby="faqs_heading2"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> The course will help you gain expertise in Data Analytics Machine learning
                                                    &amp; Data Visualization.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading3" data-toggle="collapse" href="#faqs3"
                                            aria-expanded="true" aria-controls="faqs3">
                                            <h6 class="panel-title">
                                              <i class="indicator fa fa-plus"></i> Who are eligible for the course?
                                            </h6>
                                        </div>
                                        <div id="faqs3" class="collapse" aria-labelledby="faqs_heading3"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> All Graduates / Post Graduates – Engineering, IT, Computer Science, Mathematics, Statistics,
                                                    Actuarial Science, Economics, Life Science, Electronics and MBA (All Streams) are eligible for
                                                    the course.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading4" data-toggle="collapse" href="#faqs4"
                                            aria-expanded="true" aria-controls="faqs4">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> Is there a selection process?
                                 </h6>
                                        </div>
                                        <div id="faqs4" class="collapse" aria-labelledby="faqs_heading4"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> There is no selection process for the course. </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading5" data-toggle="collapse" href="#faqs5"
                                            aria-expanded="true" aria-controls="faqs5">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> What is the course duration?
                                 </h6>
                                        </div>
                                        <div id="faqs5" class="collapse" aria-labelledby="faqs_heading5"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> The course duration is 4 months. There are two separate batches for weekdays and
                                                    weekends.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading6" data-toggle="collapse" href="#faqs6"
                                            aria-expanded="true" aria-controls="faqs6">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> Will there be tests and projects?
                                 </h6>
                                        </div>
                                        <div id="faqs6" class="collapse" aria-labelledby="faqs_heading6"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> Periodic assessment and case studies evaluations by the Indian Statistical Institute,Pune (ISI) and
                                                    edu plus now have been built in throughout the duration of the course.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading7" data-toggle="collapse" href="#faqs7"
                                            aria-expanded="true" aria-controls="faqs7">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> What are the career options after this course?
                                 </h6>
                                        </div>
                                        <div id="faqs7" class="collapse" aria-labelledby="faqs_heading7"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> After completing this course, you can work as Data Analyst, Data Engineer, Data Scientist,
                                                    Business Analyst and Machine Learning Engineer in IT Companies, In-house analytics units of
                                                    corporations, Niche analytics firms, MNC financial institutions, Pharma, Retail, Healthcare,
                                                    Oil &amp; Gas Industry, Telecommunication, Insurance &amp; Manufacturing Companies.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading8" data-toggle="collapse" href="#faqs8"
                                            aria-expanded="true" aria-controls="faqs8">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> Do you offer placement assistance?
                                 </h6>
                                        </div>
                                        <div id="faqs8" class="collapse" aria-labelledby="faqs_heading8"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> We do offer placement assistance with this course. </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading9" data-toggle="collapse" href="#faqs9"
                                            aria-expanded="true" aria-controls="faqs9">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> Will I get a certification after completing the course?
                                 </h6>
                                        </div>
                                        <div id="faqs9" class="collapse" aria-labelledby="faqs_heading9"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> Yes. A certification is awarded Jointly by the Indian Statistical Institute,Pune and edu plus now
                                                    after course completion.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3"> </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default DataAnalytics;